/* AIOS GWP Serum Auto-Add — Alice 08/07/26 (V4 draft).
   When the cart's QUALIFYING spend (everything except the serum itself) reaches
   $180 AU, silently add 1 free Flyaway Serum, tagged `_gwp:1` so we only ever
   auto-remove our own addition. Drop below $180 -> auto-remove it. Shopify's
   "GWP" automatic discount makes the line $0.

   08/07/26 robustness pass (fixes "serum only showed after a page refresh"):
   the theme opens/renders the cart drawer the instant you add an item — a beat
   BEFORE our reactive add lands — so the open drawer showed the pre-serum cart.
   Now we (1) subscribe with a retry in case pub/sub isn't ready, (2) also react to
   any add-to-cart click + cart-drawer open, and (3) re-render the drawer ~350ms
   after adding the serum so it appears without a refresh.

   `publish`, `subscribe`, `PUB_SUB_EVENTS` are bare theme globals (assets/constants.js
   + pubsub.js), referenced with typeof guards. Marker: AIOS-GWP-SERUM. */
(function () {
  var SERUM_VARIANT = 50387995656385;   // Flyaway Fix Serum — Free Gift
  var THRESHOLD = 18000;                 // cents — qualifying (ex-serum) subtotal
  var PROP = '_gwp';
  var busy = false;
  var dbt = null;

  function serumLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id === SERUM_VARIANT) return cart.items[i];
    }
    return null;
  }

  function qualifyingCents(cart) {
    var base = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.id === SERUM_VARIANT) continue;
      var lp = (it.final_line_price != null) ? it.final_line_price : it.line_price;
      base += (lp || 0);
    }
    return base;
  }

  function applySections(sections) {
    if (!sections) return;
    var dp = new DOMParser();
    if (sections['cart-drawer']) {
      var nd = dp.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (nd && cur) cur.innerHTML = nd.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var nb = dp.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
      var cb = document.querySelector('#cart-icon-bubble');
      if (nb && cb) cb.innerHTML = nb.innerHTML;
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aios-gwp' });
      }
    } catch (e) {}
  }

  function mutate(url, body, done) {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = location.pathname;
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { busy = false; applySections(res.sections); if (done) done(); })
      .catch(function () { busy = false; });
  }

  // Pure re-render of the drawer from the CURRENT server cart (no cart change).
  // Wins the race against the theme rendering the drawer before our serum add landed.
  function renderCart() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { applySections(res.sections); })
      .catch(function () {});
  }

  function reconcile() {
    if (busy) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (busy) return;
        var line = serumLine(cart);
        var mine = line && line.properties && (line.properties[PROP] === '1' || line.properties[PROP] === 1);
        var qc = qualifyingCents(cart);
        if (qc >= THRESHOLD && !line) {
          busy = true;
          var props = {}; props[PROP] = '1';
          mutate('/cart/add.js', { items: [{ id: SERUM_VARIANT, quantity: 1, properties: props }] },
            function () { setTimeout(renderCart, 350); });
        } else if (qc < THRESHOLD && line) {
          // AIOS-GWP-REMOVE-ALWAYS (Alice 13/07/26): remove the free gift whenever qualifying
          // spend is below $180 — regardless of the `_gwp` tag. This hidden gift variant is
          // never a legitimate standalone cart line, so a lingering one (e.g. added by an older
          // version / left over from testing, so `mine` is false) must still be cleared.
          busy = true;
          mutate('/cart/change.js', { id: line.key, quantity: 0 },
            function () { setTimeout(renderCart, 350); });
        } else if (line && line.quantity > 1) {
          // Free gift is 1-per-cart, always. If any path bumped it past 1, snap back.
          busy = true;
          mutate('/cart/change.js', { id: line.key, quantity: 1 },
            function () { setTimeout(renderCart, 350); });
        }
      })
      .catch(function () {});
  }

  function reconcileSoon(ms) { clearTimeout(dbt); dbt = setTimeout(reconcile, ms || 250); }

  function onPubSub() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (ev && ev.source === 'aios-gwp') return; // ignore our own publishes (no loop)
          reconcile();
        });
        return true;
      }
    } catch (e) {}
    return false;
  }

  function watchDrawerOpen() {
    var d = document.querySelector('cart-drawer#CartDrawer, cart-drawer, #CartDrawer');
    if (d && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (d.classList && (d.classList.contains('active') || d.classList.contains('animate'))) reconcileSoon(60);
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function wire() {
    // AU only — matches the store's AU free-shipping ladder.
    if (typeof window.AIOS_GWP_COUNTRY !== 'undefined' && window.AIOS_GWP_COUNTRY !== 'AU') return;

    // 1) reactive: theme cart events (retry ~5s in case pub/sub loads late)
    if (!onPubSub()) {
      var tries = 0;
      var iv = setInterval(function () { if (onPubSub() || ++tries > 50) clearInterval(iv); }, 100);
    }
    // 2) catch-all: any add-to-cart click -> reconcile after the theme's add completes;
    //    any cart-open click -> quick sync.
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (el.closest('[name="add"], .product-form__submit, .quick-add__submit, [data-aios-add]')) reconcileSoon(700);
      else if (el.closest('cart-remove-button, .cart-remove-button, [id^="Remove-"], .quantity__button, quantity-input button')) reconcileSoon(500);
      else if (el.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart"]')) reconcileSoon(150);
    }, true);
    // 3) when the drawer opens, sync (covers add paths that don't publish cartUpdate)
    watchDrawerOpen();
    // 4) initial pass on load
    reconcile();
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();
